import React from 'react';

type TabIconsProps = {
  width?: number;
  height?: number;
};
export const AccountIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M16 3.14c-7.102 0-12.86 5.758-12.86 12.86s5.758 12.86 12.86 12.86c7.102 0 12.86-5.758 12.86-12.86s-5.758-12.86-12.86-12.86zM0.25 16c0-8.698 7.052-15.75 15.75-15.75s15.75 7.052 15.75 15.75c0 8.698-7.052 15.75-15.75 15.75s-15.75-7.052-15.75-15.75z'
      fill='currentColor'
    />
    <path
      d='M16 9.498c-1.836 0-3.323 1.488-3.323 3.323s1.488 3.323 3.323 3.323c1.836 0 3.323-1.488 3.323-3.323s-1.488-3.323-3.323-3.323zM9.787 12.821c0-3.431 2.782-6.213 6.213-6.213s6.213 2.782 6.213 6.213-2.782 6.213-6.213 6.213c-3.431 0-6.213-2.782-6.213-6.213z'
      fill='currentColor'
    />
    <path
      d='M9.318 22.711c0.833-1.131 2.154-1.798 3.558-1.798h6.245c1.404 0 2.725 0.667 3.558 1.798l2.429 3.297-2.327 1.714-2.429-3.297c-0.288-0.391-0.746-0.622-1.232-0.622h-6.245c-0.486 0-0.943 0.231-1.232 0.622l-2.43 3.297-2.327-1.714 2.43-3.297z'
      fill='currentColor'
    />
  </svg>
);

export const CartIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M3.217 3.261c0.165-0 0.321 0.058 0.442 0.159s0.199 0.238 0.224 0.384l0.003 0.016 3.675 19.911c0.142 0.811 0.568 1.543 1.199 2.069 0.633 0.528 1.433 0.816 2.256 0.816h13.83c0.782 0 1.416-0.634 1.416-1.416s-0.634-1.416-1.416-1.416h-13.83c-0.164 0-0.321-0.057-0.443-0.159s-0.199-0.238-0.224-0.385l-0.003-0.017-3.675-19.912c-0.142-0.811-0.569-1.542-1.2-2.068-0.633-0.528-1.432-0.815-2.255-0.815h-1.372c-0.782 0-1.415 0.634-1.415 1.415s0.634 1.416 1.415 1.416h1.372z'
      fill='currentColor'
    />
    <path
      d='M6.092 8.569h22.904l-1.749 7.524c-0.141 0.607-0.463 1.127-0.892 1.488-0.427 0.359-0.938 0.543-1.451 0.543h-16.854v2.831h16.854c2.471-0 4.551-1.858 5.101-4.22l1.855-7.978c0.081-0.347 0.087-0.71 0.018-1.059s-0.212-0.684-0.426-0.979c-0.213-0.293-0.493-0.541-0.824-0.714-0.33-0.173-0.699-0.266-1.078-0.266h-23.457v2.831z'
      fill='currentColor'
    />
    <path
      d='M8.923 29.447c0 1.173 0.951 2.123 2.123 2.123s2.123-0.951 2.123-2.123c0-1.173-0.951-2.123-2.123-2.123s-2.123 0.951-2.123 2.123z'
      fill='currentColor'
    />
    <path
      d='M21.662 29.447c0 1.173 0.951 2.123 2.123 2.123s2.123-0.951 2.123-2.123c0-1.173-0.951-2.123-2.123-2.123s-2.123 0.951-2.123 2.123z'
      fill='currentColor'
    />
  </svg>
);

export const LoyaltyIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M15.515 2.847c-6.997 0-12.668 5.672-12.668 12.668s5.672 12.668 12.668 12.668c6.997 0 12.668-5.672 12.668-12.668s-5.672-12.668-12.668-12.668zM0 15.515c0-8.569 6.946-15.515 15.515-15.515s15.515 6.946 15.515 15.515c0 8.569-6.946 15.515-15.515 15.515s-15.515-6.946-15.515-15.515z'
      fill='currentColor'
    />
    <path
      d='M15.515 6.303c0.669 0 1.252 0.457 1.412 1.107 0.52 2.118 1.086 3.389 1.909 4.317 0.82 0.925 2.030 1.66 4.151 2.419 0.579 0.207 0.965 0.755 0.965 1.369s-0.386 1.162-0.965 1.369c-2.121 0.759-3.33 1.494-4.151 2.419-0.823 0.928-1.389 2.2-1.909 4.317-0.16 0.65-0.743 1.107-1.412 1.107s-1.253-0.458-1.413-1.108c-0.52-2.117-1.085-3.388-1.908-4.316-0.82-0.925-2.030-1.66-4.151-2.419-0.579-0.207-0.965-0.755-0.965-1.369s0.386-1.162 0.965-1.369c2.121-0.759 3.33-1.493 4.151-2.419 0.823-0.928 1.388-2.199 1.908-4.316 0.16-0.65 0.743-1.108 1.413-1.108zM15.514 12.015c-0.324 0.593-0.698 1.14-1.143 1.642-0.649 0.733-1.414 1.334-2.307 1.858 0.893 0.524 1.657 1.125 2.307 1.858 0.445 0.502 0.819 1.048 1.143 1.641 0.324-0.593 0.7-1.139 1.145-1.641 0.649-0.732 1.412-1.335 2.304-1.858-0.892-0.523-1.655-1.126-2.304-1.858-0.445-0.502-0.82-1.049-1.145-1.642z'
      fill='currentColor'
    />
  </svg>
);

export const PayIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M4 21.333v-10.667c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v10.667c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M14.667 16v-5.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v5.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M9.333 16v-5.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v5.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M25.333 21.333v-10.667c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v10.667c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M20 16v-5.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v5.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M19.714 20c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-7.428c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333h7.428z'
      fill='currentColor'
    />
    <path
      d='M0 5.333v-4c0-0.736 0.597-1.333 1.333-1.333h4c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-2.667v2.667c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M29.333 5.333v-2.667h-2.667c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333h4c0.736 0 1.333 0.597 1.333 1.333v4c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333z'
      fill='currentColor'
    />
    <path
      d='M0 26.667c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v2.667h2.667c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-4c-0.736 0-1.333-0.597-1.333-1.333v-4z'
      fill='currentColor'
    />
    <path
      d='M29.333 26.667c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333v4c0 0.736-0.597 1.333-1.333 1.333h-4c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333h2.667v-2.667z'
      fill='currentColor'
    />
  </svg>
);

export const ShopIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M3.114 11.705c0-0.791 0.641-1.432 1.432-1.432h22.909c0.791 0 1.432 0.641 1.432 1.432v14.318c0 3.163-2.564 5.727-5.727 5.727h-14.318c-3.163 0-5.727-2.564-5.727-5.727v-14.318zM5.977 13.136v12.886c0 1.582 1.282 2.864 2.864 2.864h14.318c1.582 0 2.864-1.282 2.864-2.864v-12.886h-20.045z'
      fill='currentColor'
    />
    <path
      d='M8.841 7.409c0-3.954 3.205-7.159 7.159-7.159s7.159 3.205 7.159 7.159v2.864h-2.864v-2.864c0-2.372-1.923-4.295-4.295-4.295s-4.295 1.923-4.295 4.295v2.864h-2.864v-2.864z'
      fill='currentColor'
    />
    <path
      d='M8.841 16c0-0.791 0.641-1.432 1.432-1.432s1.432 0.641 1.432 1.432v1.432c0 0.791-0.641 1.432-1.432 1.432s-1.432-0.641-1.432-1.432v-1.432z'
      fill='currentColor'
    />
    <path
      d='M20.295 16c0-0.791 0.641-1.432 1.432-1.432s1.432 0.641 1.432 1.432v1.432c0 0.791-0.641 1.432-1.432 1.432s-1.432-0.641-1.432-1.432v-1.432z'
      fill='currentColor'
    />
  </svg>
);

export const ShopFilledIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M16 0.25c3.954 0 7.159 3.205 7.159 7.159v2.864h4.295c0.791 0 1.432 0.641 1.432 1.432v14.318c0 3.163-2.564 5.727-5.727 5.727h-14.318c-3.163 0-5.727-2.564-5.727-5.727v-14.318c0-0.791 0.641-1.432 1.432-1.432h4.295v-2.864c0-3.954 3.205-7.159 7.159-7.159zM20.295 10.273v-2.864c0-2.372-1.923-4.295-4.295-4.295s-4.295 1.923-4.295 4.295v2.864h8.591zM10.273 14.568c-0.791 0-1.432 0.641-1.432 1.432v1.432c0 0.791 0.641 1.432 1.432 1.432s1.432-0.641 1.432-1.432v-1.432c0-0.791-0.641-1.432-1.432-1.432zM21.727 14.568c-0.791 0-1.432 0.641-1.432 1.432v1.432c0 0.791 0.641 1.432 1.432 1.432s1.432-0.641 1.432-1.432v-1.432c0-0.791-0.641-1.432-1.432-1.432z'
      fill='currentColor'
    />
  </svg>
);

export const SpecialsIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32'>
    <path
      d='M28.936 3.064h-11.94l-13.518 13.518c-0.55 0.55-0.55 1.441 0 1.99l9.95 9.95c0.55 0.55 1.441 0.55 1.99 0l13.518-13.518v-11.94zM29.639 0.25c1.166 0 2.111 0.945 2.111 2.111v12.936c0 0.56-0.222 1.097-0.618 1.493l-13.725 13.725c-1.649 1.649-4.322 1.649-5.97 0l-9.95-9.95c-1.649-1.649-1.649-4.322 0-5.97l13.725-13.725c0.396-0.396 0.933-0.618 1.493-0.618h12.936z'
      fill='currentColor'
    />
    <path
      d='M23.378 11.608c-0.824 0.824-2.161 0.824-2.985 0s-0.824-2.161 0-2.985c0.824-0.824 2.161-0.824 2.985 0s0.824 2.161 0 2.985z'
      fill='currentColor'
    />
  </svg>
);

export const MoreIcon = ({ width = 22, height = 22 }: TabIconsProps): JSX.Element => (
  <svg xmlns='http://www.w3.org/2000/svg' height={height} viewBox='0 -960 960 960' width={width} fill='currentColor'>
    <path d='M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z' />
  </svg>
);
